import { AVATAR_DATA } from './constants';

function Avatars() {
  return (
    <div className='flex flex-col gap-8 md:gap-3 justify-between text-white'>
      <div className='flex flex-row gap-0 md:gap-7 justify-between'>
        {AVATAR_DATA.map(({ image, alt }, index) => {
          return (
            <div
              key={alt}
              className={`flex flex-col gap-2 justify-center items-center w-80 ${index !== 0 ? '-ml-4 md:ml-0' : ''}`}
            >
              <img
                className='not-prose h-28 w-28 md:h-40 md:w-40 rounded-full aspect-square object-cover'
                src={image}
                alt={alt}
              />
            </div>
          );
        })}
      </div>
      <div className='flex flex-col md:flex-row gap-7 justify-start md:justify-between'>
        {AVATAR_DATA.map(({ title, description }, index) => {
          return (
            <div
              key={index}
              className='flex flex-col gap-1 justify-start items-start md:gap-2 md:justify-center md:items-center w-full md:w-80 text-left md:text-center'
            >
              <span className='font-body-18 font-bold'>{title}</span>
              <span className='font-body-14 font-light'>{description}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Avatars;
